/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActionMode } from "./ActionMode";
import { ActionMessage } from "./ActionMessage";
import { ActionSchedule } from "./ActionSchedule";
import { InputForm } from "./InputForm";
import { ActionConstraint } from "./ActionConstraint";
import { ActionMount } from "./ActionMount";
import { Guide } from "./Guide";
import { Guardrail } from "./Guardrail";
import { ActionId } from "./ActionId";
export const ActionWithoutLabel = core.serialization.object({
    slug: core.serialization.string().optional(),
    operation: core.serialization.string().optional(),
    mode: ActionMode.optional(),
    tooltip: core.serialization.string().optional(),
    messages: core.serialization.list(ActionMessage).optional(),
    type: core.serialization.string().optional(),
    description: core.serialization.string().optional(),
    schedule: ActionSchedule.optional(),
    primary: core.serialization.boolean().optional(),
    confirm: core.serialization.boolean().optional(),
    icon: core.serialization.string().optional(),
    requireAllValid: core.serialization.boolean().optional(),
    requireSelection: core.serialization.boolean().optional(),
    inputForm: InputForm.optional(),
    constraints: core.serialization.list(ActionConstraint).optional(),
    mount: ActionMount.optional(),
    guide: Guide.optional(),
    guardrail: Guardrail.optional(),
    createdFrom: ActionId.optional(),
    lastPropagatedAt: core.serialization.date().optional(),
    deletedAt: core.serialization.date().optional(),
    invalidConditionalMessaging: core.serialization.boolean().optional(),
    validRecordsMessage: core.serialization.string().optional(),
    invalidRecordsMessage: core.serialization.string().optional(),
});
